import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";
import {useFormikContext} from "formik";
import type {Dispatch} from "redux";

import {usePrevious} from "@pg-mono/hooks";

import {IRPStore} from "../../../app/rp_reducer";
import {useShouldShowPrice} from "../../../hooks/use_should_show_price";
import {ISentLeadActions, setDidSubmitOnMountAction} from "../../../lead/reducers/lead_form_reducer";
import {OfferType} from "../../../offer/types/OfferType";
import {ApplicationVariant} from "../../types/ApplicationVariant";
import {IApplicationFormValues} from "../../types/IApplicationFormValues";
import {ApplicationCreditForm} from "./components/ApplicationCreditForm";
import {ApplicationDefaultForm} from "./components/ApplicationDefaultForm";
import {ApplicationRetargetingForm} from "./components/ApplicationRetargetingForm";
import {useApplicationFormContext} from "./ApplicationFormContext";

interface IProps {
    submitOnMount?: boolean;
    applicationVariant?: ApplicationVariant;
}

export const ApplicationFormBody = (props: IProps) => {
    const {submitOnMount} = props;

    const dispatch: Dispatch<ISentLeadActions> = useDispatch();

    const {offer, property, vendor, isAuthenticated, formPreviouslySent, hideQuestions, alwaysShowFields, onCloseModal, leadIsSubmitting} =
        useApplicationFormContext();

    const {values: formValues, handleSubmit} = useFormikContext<IApplicationFormValues>();

    const didSubmitOnMount = useSelector((state: IRPStore) => state.leadForm.didSubmitOnMount);

    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: offer?.configuration.price_visibility,
        vendorPriceVisibility: vendor?.configuration.price_visibility,
        vendorId: vendor?.id || 0
    });

    // field visibility state
    const showTextAreaOnly = hideQuestions || offer?.type === OfferType.COMMERCIAL;
    const [showNameField, setShowNameField] = useState(true);
    const [showEmailField, setShowEmailField] = useState(true);
    const [showPhoneField, setShowPhoneField] = useState(true);
    const [showMktEmailField, setShowMktEmailField] = useState(!formValues.marketing_email);
    const [showMktSmsField, setShowMktSmsField] = useState(!formValues.marketing_sms);

    const validateFieldsVisibility = () => {
        setShowNameField(alwaysShowFields || !formValues.name);
        setShowEmailField(alwaysShowFields || !formValues.email);
        setShowPhoneField(alwaysShowFields || !formValues.phone.number);
        setShowMktEmailField(!formValues.marketing_email);
        setShowMktSmsField(!formValues.marketing_sms);
    };

    const showAllInputFields = () => {
        setShowNameField(true);
        setShowEmailField(true);
        setShowPhoneField(true);
        setShowMktEmailField(true);
        setShowMktSmsField(true);
    };

    useEffect(() => {
        if (formPreviouslySent) {
            validateFieldsVisibility();
        }
    }, []);

    const prevFormPreviouslySent = usePrevious(formPreviouslySent, formPreviouslySent);
    useEffect(() => {
        if (!prevFormPreviouslySent && formPreviouslySent) {
            validateFieldsVisibility();
        }
    }, [formPreviouslySent]);

    useEffect(() => {
        if (submitOnMount && !didSubmitOnMount) {
            handleSubmit();
            dispatch<ISentLeadActions>(setDidSubmitOnMountAction(true));
        }

        return () => {
            if (submitOnMount) {
                dispatch<ISentLeadActions>(setDidSubmitOnMountAction(false));
            }
        };
    }, []);

    const hasPropertyShownPrice = !!vendor?.configuration.force_show_price && property && property.price;
    const showRevealPriceButton = hasPropertyShownPrice ? false : !offer?.stats?.ranges_price_m2_min || !!property;

    switch (props.applicationVariant) {
        case ApplicationVariant.CREDIT:
            return (
                <div css={formWrapperCreditStyle}>
                    <ApplicationCreditForm
                        onCloseModal={onCloseModal}
                        showPropertyNotificationField={showMktEmailField}
                        leadIsSubmitting={leadIsSubmitting}
                        isAuthenticated={isAuthenticated}
                        formPreviouslySent={formPreviouslySent}
                        vendor={vendor}
                        offerPrivacyPolicyUrl={offer?.configuration.privacy_policy_url}
                        offerPersonalDataProcessorName={offer?.configuration.personal_data_processor_name}
                        offerPersonalDataProcessorUrl={offer?.configuration.personal_data_processor_url}
                        offerType={offer?.type}
                    />
                </div>
            );
        case ApplicationVariant.PROPERTY_WITH_RETARGETING:
            return (
                <ApplicationRetargetingForm
                    showRevealPriceButton={showRevealPriceButton}
                    showEmailField={showEmailField}
                    showPhoneField={showPhoneField}
                    showNameField={showNameField}
                    showAllInputFields={showAllInputFields}
                    showTextAreaOnly={showTextAreaOnly}
                    showMktEmailField={showMktEmailField}
                    showMktSmsField={showMktSmsField}
                />
            );
        default:
            return (
                <ApplicationDefaultForm
                    showRevealPriceButton={!shouldShowPrice}
                    showEmailField={showEmailField}
                    showPhoneField={showPhoneField}
                    showNameField={showNameField}
                    showAllInputFields={showAllInputFields}
                    showTextAreaOnly={showTextAreaOnly}
                    showMktEmailField={showMktEmailField}
                    showMktSmsField={showMktSmsField}
                />
            );
    }
};

//  Styles

const formWrapperCreditStyle = (theme: Theme) => css`
    display: flex;
    flex-direction: column-reverse;
    background-color: ${theme.colors.gray[100]};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";
import {useFormikContext} from "formik";
import type {Dispatch} from "redux";

import {usePrevious} from "@pg-mono/hooks";

import {IRPStore} from "../../../app/rp_reducer";
import {useShouldShowPrice} from "../../../hooks/use_should_show_price";
import {ISentLeadActions, setDidSubmitOnMountAction} from "../../../lead/reducers/lead_form_reducer";
import {OfferType} from "../../../offer/types/OfferType";
import {ApplicationVariant} from "../../types/ApplicationVariant";
import {IApplicationFormValues} from "../../types/IApplicationFormValues";
import {ApplicationCreditForm} from "./components/ApplicationCreditForm";
import {ApplicationDefaultForm} from "./components/ApplicationDefaultForm";
import {ApplicationRetargetingForm} from "./components/ApplicationRetargetingForm";
import {useApplicationFormContext} from "./ApplicationFormContext";

interface IProps {
    submitOnMount?: boolean;
    applicationVariant?: ApplicationVariant;
}

export const ApplicationFormBody = (props: IProps) => {
    const {submitOnMount} = props;

    const dispatch: Dispatch<ISentLeadActions> = useDispatch();

    const {offer, property, vendor, isAuthenticated, formPreviouslySent, hideQuestions, alwaysShowFields, onCloseModal, leadIsSubmitting} =
        useApplicationFormContext();

    const {values: formValues, handleSubmit} = useFormikContext<IApplicationFormValues>();

    const didSubmitOnMount = useSelector((state: IRPStore) => state.leadForm.didSubmitOnMount);

    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: offer?.configuration.price_visibility,
        vendorPriceVisibility: vendor?.configuration.price_visibility,
        vendorId: vendor?.id || 0
    });

    // field visibility state
    const showTextAreaOnly = hideQuestions || offer?.type === OfferType.COMMERCIAL;
    const [showNameField, setShowNameField] = useState(true);
    const [showEmailField, setShowEmailField] = useState(true);
    const [showPhoneField, setShowPhoneField] = useState(true);
    const [showMktEmailField, setShowMktEmailField] = useState(!formValues.marketing_email);
    const [showMktSmsField, setShowMktSmsField] = useState(!formValues.marketing_sms);

    const validateFieldsVisibility = () => {
        setShowNameField(alwaysShowFields || !formValues.name);
        setShowEmailField(alwaysShowFields || !formValues.email);
        setShowPhoneField(alwaysShowFields || !formValues.phone.number);
        setShowMktEmailField(!formValues.marketing_email);
        setShowMktSmsField(!formValues.marketing_sms);
    };

    const showAllInputFields = () => {
        setShowNameField(true);
        setShowEmailField(true);
        setShowPhoneField(true);
        setShowMktEmailField(true);
        setShowMktSmsField(true);
    };

    useEffect(() => {
        if (formPreviouslySent) {
            validateFieldsVisibility();
        }
    }, []);

    const prevFormPreviouslySent = usePrevious(formPreviouslySent, formPreviouslySent);
    useEffect(() => {
        if (!prevFormPreviouslySent && formPreviouslySent) {
            validateFieldsVisibility();
        }
    }, [formPreviouslySent]);

    useEffect(() => {
        if (submitOnMount && !didSubmitOnMount) {
            handleSubmit();
            dispatch<ISentLeadActions>(setDidSubmitOnMountAction(true));
        }

        return () => {
            if (submitOnMount) {
                dispatch<ISentLeadActions>(setDidSubmitOnMountAction(false));
            }
        };
    }, []);

    const hasPropertyShownPrice = !!vendor?.configuration.force_show_price && property && property.price;
    const showRevealPriceButton = hasPropertyShownPrice ? false : !offer?.stats?.ranges_price_m2_min || !!property;

    switch (props.applicationVariant) {
        case ApplicationVariant.CREDIT:
            return (
                <div css={formWrapperCreditStyle}>
                    <ApplicationCreditForm
                        onCloseModal={onCloseModal}
                        showPropertyNotificationField={showMktEmailField}
                        leadIsSubmitting={leadIsSubmitting}
                        isAuthenticated={isAuthenticated}
                        formPreviouslySent={formPreviouslySent}
                        vendor={vendor}
                        offerPrivacyPolicyUrl={offer?.configuration.privacy_policy_url}
                        offerPersonalDataProcessorName={offer?.configuration.personal_data_processor_name}
                        offerPersonalDataProcessorUrl={offer?.configuration.personal_data_processor_url}
                        offerType={offer?.type}
                    />
                </div>
            );
        case ApplicationVariant.PROPERTY_WITH_RETARGETING:
            return (
                <ApplicationRetargetingForm
                    showRevealPriceButton={showRevealPriceButton}
                    showEmailField={showEmailField}
                    showPhoneField={showPhoneField}
                    showNameField={showNameField}
                    showAllInputFields={showAllInputFields}
                    showTextAreaOnly={showTextAreaOnly}
                    showMktEmailField={showMktEmailField}
                    showMktSmsField={showMktSmsField}
                />
            );
        default:
            return (
                <ApplicationDefaultForm
                    showRevealPriceButton={!shouldShowPrice}
                    showEmailField={showEmailField}
                    showPhoneField={showPhoneField}
                    showNameField={showNameField}
                    showAllInputFields={showAllInputFields}
                    showTextAreaOnly={showTextAreaOnly}
                    showMktEmailField={showMktEmailField}
                    showMktSmsField={showMktSmsField}
                />
            );
    }
};

//  Styles

const formWrapperCreditStyle = (theme: Theme) => css`
    display: flex;
    flex-direction: column-reverse;
    background-color: ${theme.colors.gray[100]};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;
